import { Cart } from '~/modules/GraphQL/types';

interface CartOfferProductsInterface {
  sku: string;
  enabled: boolean;
  offer_label: string;
  offer_image: string;
  offer_title: string;
}

type CartWithOfferProducts = Cart & {
  offer_products?: CartOfferProductsInterface[];
};

export const getOfferProducts = (cart: CartWithOfferProducts): CartOfferProductsInterface[] => {
  if (!cart || !cart.offer_products) {
    return [];
  }

  return cart.offer_products;
};
